export default {
  selectMenu: {
    height: 45,
  },
  outlined: {
    display: 'flex',
    alignItems: 'center',
  },
};
